import React from 'react';
import { Button, Col, Row, Typography } from 'antd';
import CardEventHome from 'src/components/CardEvent/EventHomeList';
import classes from './index.module.less';
const EventHomeContainer = (props: any) => {
  const dataEvent = props.event.slice(0, 2);
  return <div className={classes['page-body-wrap']} style={{
    paddingBottom: '60px'
  }}>
			<div className="container">
				<div style={{
        backgroundColor: '#fff'
      }}>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<div className={classes.headContact}>
								<h2 className={classes.title}>Event Spesial buat Mama</h2>
								<Typography className={classes.paragraph}>
									Kumpulan event yang cocok untuk Mama
								</Typography>
							</div>
						</Col>
					</Row>

					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<CardEventHome data={dataEvent} />
						</Col>
					</Row>
					<div className={classes.btnFooter}>
						<Button className={classes.btn} href="/event" size="large" id="home-lihat-semua-event">
							Lihat Semua Event
						</Button>
					</div>
				</div>
			</div>
		</div>;
};
export default EventHomeContainer;